import { render, staticRenderFns } from "./infoReasonRejectProductVideo.vue?vue&type=template&id=ab2ba4b6&scoped=true&"
import script from "./infoReasonRejectProductVideo.vue?vue&type=script&lang=js&"
export * from "./infoReasonRejectProductVideo.vue?vue&type=script&lang=js&"
import style0 from "./infoReasonRejectProductVideo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./infoReasonRejectProductVideo.vue?vue&type=style&index=1&id=ab2ba4b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2ba4b6",
  null
  
)

export default component.exports